import {
  locationIdFormat,
  processingGroupIdFormat,
  sortingToteIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";
import { ToteNamingConfigSchema } from "./tote-naming-config";

export const addSortingTotes = {
  name: "addSortingTotes" as const,
  input: z.object({
    processingGroupId: processingGroupIdFormat.schema,
    count: z.number().int().positive(),
    locationId: locationIdFormat.schema.optional(),
    namingConfig: ToteNamingConfigSchema.optional(),
  }),
  output: z.object({ toteIds: z.array(sortingToteIdFormat.schema) }),
};
